import type { ThemeVariantMap } from "@/theme/types";

import { mySushiDarkTheme } from "./mySushi.dark";

export const mySushiTheme: ThemeVariantMap = {
  DARK: mySushiDarkTheme,
} as const;
